import React from 'react';
import { useParams } from 'react-router-dom';
import { DataGridLayout, RelatedList, RelationListLayout } from 'framework/list';
import { AmountField, DateField, FullDateField, TextField } from 'framework/ui/field';
import OpportunityStageField from 'domain/sales/opportunity/shared/field/OpportunityStageField';
import OpportunityLinkField from 'domain/sales/opportunity/shared/field/OpportunityLinkField';
import EditOpportunityButton from 'domain/sales/opportunity/shared/button/EditOpportunityButton';
import { CreateButton } from 'framework/ui/ui-builder';
import { useShowContext } from 'framework/show';
import { useOpportunityUrl } from 'domain/sales/opportunity/opportunityRouting';
import { CREATE_OPPORTUNITY } from 'domain/sales/salesService';

type RelatedOpportunitiesListProps = {
  getDataMethod: () => Promise<any>;
  isActionsVisible?: boolean;
};

const RelatedOpportunitiesList = ({ getDataMethod, isActionsVisible = false }: RelatedOpportunitiesListProps) => {
  const { data } = useShowContext();
  const accountName = data.getValueBySource('accountName');
  const { id } = useParams<Dictionary<string>>();
  const { getCreateUrl } = useOpportunityUrl();

  const actions = isActionsVisible
    ? [
        <CreateButton
          url={`${getCreateUrl({
            accountId: id!,
            accountName,
          })}`}
          variant="contained"
          label="Create opportunity"
          size="small"
          key="create-opportunity"
          permissionToCheck={CREATE_OPPORTUNITY}
        />,
      ]
    : [];

  return (
    <RelatedList getDataMethod={getDataMethod}>
      <RelationListLayout header="Opportunities" headerVariant="h4" actions={actions}>
        <DataGridLayout buttons={[<EditOpportunityButton outline source="id" />]} isSmallTable showTotal={false}>
          <TextField source="id" label="Opportunity ID" />
          <OpportunityLinkField source="name" idSource="id" label="Opportunity name" />
          <OpportunityStageField source="stage" label="Opportunity stage" />
          <AmountField source="amount" label="Amount (USD)" />
          <DateField source="closeDate" label="Close date" />
          <FullDateField source="createdAt" label="Created date" />
          <FullDateField source="updatedAt" label="Last modified date" />
        </DataGridLayout>
      </RelationListLayout>
    </RelatedList>
  );
};

export default RelatedOpportunitiesList;
